export const getNumberFromRange = (start: number, end: number, value: number) =>
  start + (end - start) * value;
